export default __webpack_public_path__ + "static/media/factory_icon.af5dce0c.svg";